import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AUDIO_IFRAME_RENDERED } from '../constants/data-aids';

export default class Audio extends Component {
  static propTypes = {
    title: PropTypes.string,
    audioSrc: PropTypes.string,
    height: PropTypes.string,
    renderMode: PropTypes.string
  };

  render() {
    const { title, audioSrc, height } = this.props;

    return (
      <iframe
        data-aid={ AUDIO_IFRAME_RENDERED }
        height={ height }
        src={ typeof window !== 'undefined' && audioSrc }
        width='100%'
        scrolling='no'
        frameBorder='no'
        title={ title }
      />
    );
  }
}
